export default __webpack_public_path__ + "static/media/gaji.e0f4fa7f.png";